import React from 'react';
import TranslationNamespaces from '../../locales/TranslationNamespaces';
import HeaderWithDescription from '../Shared/HeaderWithDescription';
import MessageBox from '../Shared/MessageBoxes/MessageBox';
import FlexContainer from '../Shared/FlexContainers/FlexContainer';
import CenteredDescription from '../Shared/CenteredDescription';
import { useCache } from '../../state/CachingContext';

const CheckEmail = (): JSX.Element => {
  const namespace = TranslationNamespaces.recovery;
  const { getCache } = useCache();

  const email = getCache('email');

  return (
    <>
      <HeaderWithDescription translationNamespace={namespace} description='descriptionCheckEmail'>
        <MessageBox text={email} emailBox />
      </HeaderWithDescription>

      <FlexContainer>
        <CenteredDescription description='canCloseWindow' translationNamespace={namespace} />
      </FlexContainer>
    </>
  );
};

export default CheckEmail;
